import ShopaholicProductList from '@lovata/shopaholic-product-list/shopaholic-product-list';
import ShopaholicPagination from '@lovata/shopaholic-product-list/shopaholic-pagination';
import ShopaholicFilterPanel from '@lovata/shopaholic-filter-panel/shopaholic-filter-panel';
import ShopaholicFilterPrice from '@lovata/shopaholic-filter-panel/shopaholic-filter-price';
import ShopaholicSorting from '@lovata/shopaholic-product-list/shopaholic-sorting';
import noUiSlider from 'nouislider';
import LazyLoad from '../../../../js/lazy-load';
import Select from '../../../form/select/select';
import ListToggle from '../catalog-list/catalog-list-toggle';
import wNumb from '../../../../js/wNumb';

export default new class FilterPanel {
  constructor() {
    this.sCatalogWrapper = '.catalog__wrapper';
    this.preLoaderSelector = '.catalog__preloader';
    this.filterPreLoaderElector = '.filter__preloader';
    this.brandWrapperSelector = '._shopaholic-brand-filter-wrapper';
    this.saleFilterWrapper = '._shopaholic-sale-filter-wrapper';
    this.filterBtnWrapperSelector = '.filter-bar__filter-btn-wrapper';
    this.filterPanelWrapper = '.filter__wrapper';
    this.filterBarSelector = '.filter-bar';
    this.sTitleWrapper = '.catalog__title-wrapper';

    this.sliderData = {};

    this.mediaQueryList = window.matchMedia('(min-width: 769px)');

    this.selectorClass = '.between-selector';
    this.propertyBetweenWidget();

    this.priceRangeWidget();
    this.handlers();
  }

  handlers() {
    if (!document.querySelector(this.sCatalogWrapper)) return;

    this.initFilterHandlers();

    document.addEventListener('DOMContentLoaded', () => {
      this.chooseAjaxHelper();
    });

    this.mediaQueryList.addListener(() => {
      this.chooseAjaxHelper();
    });
  }

  isDesktop() {
    return this.mediaQueryList.matches;
  }

  chooseAjaxHelper(updateAll = false) {
    if (!updateAll && !this.isDesktop()) {
      this.obListHelper = this.updateFilterPanelAjax();
    } else {
      this.obListHelper = this.updateAllAjax();
    }

    this.instanceArray.forEach((el) => {
      el.obProductListHelper = this.obListHelper; // eslint-disable-line no-param-reassign
    });

    return this.obListHelper;
  }

  updateAllAjax() {
    const obListHelper = new ShopaholicProductList();

    obListHelper.setAjaxRequestCallback((obRequestData) => {
      /* eslint-disable  no-param-reassign */
      obRequestData.update = {
        'product/catalog/title-ajax': this.sTitleWrapper,
        'product/catalog/catalog-ajax': this.sCatalogWrapper,
      };
      obRequestData.complete = () => {
        LazyLoad.update();
        Select.checkSelect();
        ListToggle.callbackView();
        this.updateRangeWidget();
        this.propertyBetweenWidget();

        if (!this.checkWindowPosition()) {
          const bar = $(this.filterBarSelector);

          if (!bar.length) return;

          const distance = bar.offset().top;

          $('body, html').animate({ scrollTop: distance }, 350);
        }
      };
      obRequestData.loading = this.preLoaderSelector;
      /* eslint-enable */

      return obRequestData;
    });

    return obListHelper;
  }

  checkWindowPosition() {
    const docViewTop = $(window).scrollTop();
    const docViewBottom = docViewTop + $(window).height();
    const bar = $(this.filterBarSelector);

    if (!bar.length) return true;

    const elemTop = $(this.filterBarSelector).offset().top;
    const elemBottom = elemTop + $(this.filterBarSelector).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  priceRangeWidget() {
    const range = document.querySelector('#range');

    if (range) {
      this.priceRangeData();

      this.noUiSlider = noUiSlider.create(range, this.sliderData).on('change', (values, handle) => {
        this.eventPriceRange(values, handle);
      });
    }
  }

  getRangers(dataSeries) {
    this.test = '';
    const rangers = {};
    let i;
    for (i = 0; i < dataSeries.length; i += 1) {
      // set array to first(min) element
      if (i === 0) rangers.min = [dataSeries[i], dataSeries[i + 1] - dataSeries[i]];
      const prozent = ((100 / dataSeries.length) * i).toFixed(2);
      if (i !== 0 && i < dataSeries.length - 1) {
        rangers[`${prozent}%`] = [dataSeries[i], dataSeries[i + 1] - dataSeries[i]];
      }
      if (i === dataSeries.length - 1) {
        rangers.max = [dataSeries[dataSeries.length - 1]];
      }
    }

    return rangers;
  }

  initBetweenWidget(el) {
    const elementId = el.getAttribute('id');
    const dataSeries = JSON.parse(el.getAttribute('data-series'));

    if (dataSeries.length < 2) return;

    const rangers = this.getRangers(dataSeries);

    const from = $(`#${elementId}-1`).val() ? $(`#${elementId}-1`).val() : dataSeries[0];
    const to = $(`#${elementId}-2`).val() ? $(`#${elementId}-2`).val() : dataSeries[dataSeries.length - 1];

    // eslint-disable-next-line no-console
    console.log(from);
    // eslint-disable-next-line no-console
    console.log(to);

    noUiSlider.create(el, {
      start: [
        from,
        to,
      ],
      range: rangers,
      snap: true,
      connect: true,
      pips: {
        mode: 'values',
        values: dataSeries,
        density: 100,
        format: wNumb({
          decimals: 1,
        }),
      },
    }).on('change', (values, handle) => {
      this.eventBetweenRange(values, handle, elementId);
    });
  }

  propertyBetweenWidget() {
    const ranges = document.querySelectorAll(`${this.selectorClass}`);

    [...ranges].forEach((el) => {
      this.initBetweenWidget(el);
    });
  }

  eventBetweenRange(values, handle, elementId) {
    this.values = values;
    this.handle = handle;

    $(`#${elementId}-1`).val(this.values[0]);
    $(`#${elementId}-2`).val(this.values[1]).trigger('change');
  }

  updateRangeWidget() {
    this.priceRangeData();
    this.priceRangeWidget();
  }

  priceRangeData() {
    this.handles = {
      0: 'min',
      1: 'max',
    };

    this.inputField = {
      min: document.querySelector('#min-price'),
      max: document.querySelector('#max-price'),
    };

    this.min = this.inputField.min.getAttribute('min');
    this.max = this.inputField.max.getAttribute('max');

    this.from = this.inputField.min.value ? this.inputField.min.value : this.min;
    this.to = this.inputField.max.value ? this.inputField.max.value : this.max;

    this.sliderData = {
      start: [
        this.from,
        this.to,
      ],
      connect: true,
      range: {
        min: parseInt(this.min, this.iRadix),
        max: parseInt(this.max, this.iRadix),
      },
    };
  }

  eventPriceRange(values, handle) {
    this.inputField[this.handles[handle]].value = values[handle];

    const obFilterPrice = new ShopaholicFilterPrice();
    obFilterPrice
      .setEventType('change')
      .init();

    obFilterPrice.priceChangeCallBack();

    this.chooseAjaxHelper().send();
  }

  updateFilterPanelAjax() {
    const obListHelper = new ShopaholicProductList();

    obListHelper.setAjaxRequestCallback((obRequestData) => {
      /* eslint-disable  no-param-reassign */
      obRequestData.update = {
        'product/catalog/filter/filter-ajax': this.filterPanelWrapper,
        'product/catalog/filter-bar/filter-bar-btn-ajax': this.filterBtnWrapperSelector,
      };
      obRequestData.complete = () => {
        this.updateRangeWidget();
      };
      obRequestData.loading = this.filterPreLoaderElector;
      /* eslint-enable */

      return obRequestData;
    });

    return obListHelper;
  }

  initFilterHandlers() {
    const obListHelper = this.updateAllAjax();

    const obFilterPanel = new ShopaholicFilterPanel();
    obFilterPanel.init();

    const obBrandFilterPanel = new ShopaholicFilterPanel();
    obBrandFilterPanel
      .setWrapperSelector(this.brandWrapperSelector)
      .setFieldName('brand')
      .init();

    const obSaleFilterPanel = new ShopaholicFilterPanel();
    obSaleFilterPanel
      .setWrapperSelector(this.saleFilterWrapper)
      .setFieldName('sale')
      .init();

    const obPaginationHelper = new ShopaholicPagination(obListHelper);
    obPaginationHelper.init();

    const obSortingHelper = new ShopaholicSorting(obListHelper);
    obSortingHelper.init();

    const obFilterPrice = new ShopaholicFilterPrice();
    obFilterPrice
      .setEventType('change')
      .init();

    this.instanceArray = [
      obFilterPanel,
      obBrandFilterPanel,
      obSaleFilterPanel,
      obFilterPrice,
    ];
  }
}();
